import cleanedFilename from '~/util/cleanedFilename';

export default {
  ACTION_TYPE_DROPDOWN: `${cleanedFilename(__filename)}-action-type-dropdown`,
  ADD_BUTTON: `${cleanedFilename(__filename)}-add-button`,
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  EXPAND_BUTTON: `${cleanedFilename(__filename)}-expand-button`,
};
